import React, { useState, useEffect } from "react";
import {
  Layout,
  Breadcrumb,
  Table,
  Tag,
  Space,
  Avatar,
  Button,
  Input,
  Drawer,
  Menu,
  Dropdown,
  Modal,
} from "antd";
import axios from "axios";
import Loader from "./Loader";
import AddContact from "./addContact";
import UpdateContact from "./updateContact";
import { TableChart } from "@material-ui/icons";
var dataTab = [];

const compte = localStorage.getItem("compte");
const posteCol = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;

function Contacts({ navbar, callClick, tabHeight }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputWidth, setInputWidth] = useState("0px");
  const [value, setValue] = useState("");
  const [showModelUP, setShowModelUP] = useState(false);
  const [contactInfo, setContactInfo] = useState({});

  function showModel(record) {
    setShowModelUP(true);
    var contact = {};
    contact.phoneNumber = record.phoneNumber;
    contact.name = record.name;
    contact.company = record.company;
    contact.id = record.id;
    console.log("conttttt", contact);
    setContactInfo(contact);
  }

  useEffect(() => {
    var config1 = {
      headers: {
        Authorization: token,
      },
    };
    const result1 = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${posteCol}`,
        config1,
        // config
      )
      .then((res) => {
        dataTab = [];
        //  console.log(res.data.log_voicemail)
        for (var i = 0; i < res.data.carnet_adresse.length; i++) {
          dataTab.push({
            name: res.data.carnet_adresse[i].nom_prenom,
            phoneNumber: res.data.carnet_adresse[i].tel_portable,
            company: res.data.carnet_adresse[i].adresse,
            typeContact: res.data.carnet_adresse[i].type_contact,
            id: res.data.carnet_adresse[i].id,
          });
        }
        setData(dataTab);
        setLoading(true);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          // var link = "/";
          // window.location.replace(link);
        } else {
          // console.log("AXIOS ERROR: ", err);
        }
      });
  }, []);

  function updateContactTab() {
    var config1 = {
      headers: {
        Authorization: token,
      },
    };
    const result1 = axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${posteCol}`,
        config1,
        // config
      )
      .then((res) => {
        dataTab = [];
        //  console.log(res.data.log_voicemail)
        for (var i = 0; i < res.data.carnet_adresse.length; i++) {
          dataTab.push({
            name: res.data.carnet_adresse[i].nom_prenom,
            phoneNumber: res.data.carnet_adresse[i].tel_portable,
            company: res.data.carnet_adresse[i].adresse,
            typeContact: res.data.carnet_adresse[i].type_contact,
            id: res.data.carnet_adresse[i].id,
          });
        }
        setData(dataTab);
        setLoading(true);
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          // var link = "/";
          // window.location.replace(link);
        } else {
          // console.log("AXIOS ERROR: ", err);
        }
      });
  }

  const openInput = () => {
    setInputWidth("100%");
    document.getElementById("inputSearchContact").focus();
  };

  const FilterByNameInput = (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ margin: "auto 3px auto 0" }}>Nom</div>
      <div
        className="inputIcon"
        style={{
          display: "flex",
          border: "1px solid #e6e8ec",
          borderRadius: "5px",
        }}
      >
        <div style={{ margin: "auto" }} onClick={() => openInput()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-7 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            style={{ color: "color: rgb(191, 192, 205)", margin: "auto" }}
          >
            {" "}
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />{" "}
          </svg>
        </div>
        <Input
          id="inputSearchContact"
          placeholder="Rechercher"
          value={value}
          onFocus={(e) => {
            setInputWidth("100%");
          }}
          onBlur={(e) => {
            if (e.target.value === "") {
              setInputWidth("0px");
            }
          }}
          onChange={(e) => {
            // console.log("tar", e.target.value);
            const currValue = e.target.value;
            setValue(currValue);
            const filteredData = dataTab.filter(
              (entry) =>
                entry.name.toUpperCase().includes(currValue.toUpperCase()) ||
                entry.phoneNumber
                  .toUpperCase()
                  .includes(currValue.toUpperCase()),
            );
            setData(filteredData);
          }}
          style={{
            width: inputWidth,
            border: "0",
            backgroundColor: "transparent",
            float: "right",
            textAlign: "center",
          }}
        />
      </div>
    </div>
  );

  const menu = (
    <Menu
      items={[
        {
          label: "Submit and continue",
          key: "1",
        },
      ]}
    />
  );

  const columns = [
    {
      title: FilterByNameInput,
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        return (
          <div>
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: navbar ? "space-around" : "normal",
              }}
            >
              <div style={{ width: "30%" }}>
                <div
                  style={{
                    height: "40px",
                    width: "40px",
                    backgroundColor: "#bfbfbf",
                    borderRadius: "100%",
                    // margin: "auto",
                    fontWeight: "500",
                    fontSize: "x-large",
                    color: "#929292",
                    textAlign: "-webkit-center",
                  }}
                >
                  {record.name.charAt(0)}
                </div>
              </div>
              <div
                className="tooltip"
                style={{
                  fontSize: "small",
                  width: navbar ? "30px" : "70%",
                  // overflow: "hidden",
                  // textOverflow: "ellipsis",
                  // whiteSpace: "nowrap",
                }}
              >
                <span class="tooltiptext"> {record.name}</span>
                <div
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {" "}
                  {record.name}
                </div>
              </div>
            </div>
          </div>
        );
      },
    },

    {
      title: "Numéro téléphone",
      dataIndex: "number",
      key: "number",
      render: (text, record) => {
        return (
          <div>
            <Dropdown overlay={menu} placement="bottomLeft">
              <Button onClick={() => callClick(record.phoneNumber)}>
                {" "}
                {record.phoneNumber}
              </Button>
            </Dropdown>
          </div>
        );
      },
    },
    {
      title: "Entreprise",
      dataIndex: "company",
      key: "company",
      render: (text, record) => {
        return (
          <div className="truncate" company>
            {record.company}
          </div>
        );
      },
    },
  ];

  const handleChange = (pagination, filters, sorter) => {};

  return (
    <div>
      {loading ? (
        <div className="contacts">
          <UpdateContact
            show={showModelUP}
            close={() => setShowModelUP(false)}
            // name={name}
            // number={number}
            // company={company}
            // contact_id={contact_id}
            contactInfo={contactInfo}
            updateContactTab={updateContactTab}
          />
          <Table
            locale={{ emptyText: " " }}
            columns={
              navbar
                ? columns.filter(
                    (column) =>
                      column.title !== "Durée" && column.title !== "Entreprise",
                  )
                : columns
            }
            dataSource={data}
            onChange={handleChange}
            scroll={{ y: navbar ? tabHeight : tabHeight + 65 }}
            style={{
              paddingLeft: navbar ? "0px" : "57px",
              backgroundColo: "transparent",
            }}
          />
        </div>
      ) : (
        <div className="flex justify-center">
          <Loader />
        </div>
      )}
    </div>
  );
}

export default Contacts;
